module.exports = __webpack_public_path__ + "ax.0393f575f7800c778e2e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ax.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ax.svg
// module chunks = styles